import { render, staticRenderFns } from "./Webscoket.vue?vue&type=template&id=8131b19a&scoped=true&"
import script from "./Webscoket.vue?vue&type=script&lang=js&"
export * from "./Webscoket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8131b19a",
  null
  
)

export default component.exports